import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import NewsPage from "./pages/NewsPage";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import NewsArticlePage from "./pages/NewsArticlePage/NewsArticlePage";
import defaultBackground from "assets/images/backgrounds/bg_main.jpg";
import PageLayout from "components/layout/PageLayout";

const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        footerBackground: {
            marginBottom: -100,
            paddingBottom: 100,
        },
    });
});

interface IProps {}

export default function NewsPageRoutes(props: IProps) {
    let { path } = useRouteMatch();
    const classes = useStyles();

    return (
        <>
            <div
                style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    top: 0,
                    left: 0,
                    backgroundImage: `url(${defaultBackground})`,
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                }}
            ></div>
            <PageLayout footerProps={{ classes: { background: classes.footerBackground } }}>
                <Switch>
                    <Route exact path={path} render={() => <NewsPage />} />
                    <Route path={`${path}/:articleId`}>
                        <NewsArticlePage />
                    </Route>
                </Switch>
            </PageLayout>
        </>
    );
}
